import React from 'react';
import { connect } from "react-redux";
import { withRouter, Link } from 'react-router-dom'
import {logoutAction} from "../../redux/actions/auth";
import './header.scss';

import logoImg from '~/assets/logo-text.png';
import profileImg from '~/assets/icons/profile.png';
import { MenuGridIcon } from '../../../Components/Icons/Icons';

const Header = (props) => {

    const handleLogoutUser = () => {
        props.dispatch(logoutAction());
    };

    return (
        <>
        <div className="admin-header">
            <div className="menu-icon">
                <MenuGridIcon />
            </div>
            <div className="header-navigation">
                <div className="logo">
                    <img src={logoImg} alt="logo"/>
                </div>
                <div className="profile-info">
                    <img
                        className="icon"
                        src={profileImg}
                        onClick={props.toggleMyProfile}
                    />
                    <span>{props.auth.user?.name}</span>
                    <span className="mr-4 ml-4">|</span>
                    <a className="link" onClick={(e) => handleLogoutUser()}>Log out</a>
                </div>
            </div>
        </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps)(withRouter(Header));
